import OffersInfoModal from '@/components/AgentSSNForm/OffersInfoModal/OffersInfoModal';
import EngineLandingModal from '@/components/EngineLandingModal/EngineLandingModal';
import OfferFiltersModal from '@/components/FiltersButton/OfferFiltersModal/OfferFiltersModal';
import CreditRatingForm from '@/components/FormComponents/FormBody/StepEight/CreditRatingForm';
import SSNForm from '@/components/FormComponents/FormBody/StepEleven/SSNForm';
import AnnualIncomeForm from '@/components/FormComponents/FormBody/StepFour/AnnualIncomeForm';
import EducationForm from '@/components/FormComponents/FormBody/StepNine/EducationForm';
import EmploymentForm from '@/components/FormComponents/FormBody/StepNine/EmploymentForm';
import HouseOwnForm from '@/components/FormComponents/FormBody/StepSix/HouseOwnForm';
import ModalForm from '@/components/FormComponents/FormBody/StepSix/ModalForm';
import DOBForm from '@/components/FormComponents/FormBody/StepTen/DOBForm';
import LoanReasonForm from '@/components/FormComponents/FormBody/StepThree/LoanReasonForm';
import BorrowSumForm from '@/components/FormComponents/FormBody/StepTwo/BorrowSumForm';
import PrimaryInfoModal from '@/components/OfferCard/PrimaryInfoModal/PrimaryInfoModal';
import SecondaryInfoModal from '@/components/OfferCard/SecondaryInfoModal/SecondaryInfoModal';
import WarningModal from '@/components/OfferCard/WarningModal/WarningModal';
import PreQualifiedModal from '@/components/PreQualifiedModal/PreQualifiedModal';
import UnsubscribeContent from '@/components/UnsubscribeModal/UnsubscribeContent/UnsubscribeContent';
import { ModalItem } from '@/types/modals';

export const MODAL_NAMES = {
  generalDisclosure: 'general-disclosure',
  creditAuthorization: 'credit-authorization',
  partnerList: 'partner-list',
  advertiserDisclosure: 'advertiser-disclosure',
  technicalTermsOfService: 'terms-of-service',
  technicalPrivacyPolicy: 'privacy-policy',
  eSign: 'electronic-consent',
  technicalCaliforniaPolicy: 'ca-privacy-notice',
  triPointPrivacyPolicy: 'tri-privacy',
  triPointTermsOfService: 'tri-terms',
  adDisclosure: 'ad-disclosure',
  pennieToS: 'pennie-terms-of-service',
  penniePP: 'pennie-privacy-policy',
  formSSN: 'form-ssn',
  formLoanAmount: 'form-loan-amount',
  formLoanPurpose: 'form-loan-purpose',
  formDOB: 'form-dob',
  formAddress: 'form-address',
  formCreditRating: 'form-credit-rating',
  formHouseOwn: 'form-house-own',
  formEducation: 'form-education',
  formEmployment: 'form-employment',
  formAnnualIncome: 'form-annual-income',
  unsubscribe: 'unsubscribe',
  offerPrimaryInfo: 'offers-primary-info',
  securedOffer: 'secured-offer',
  offerFilters: 'offer-filters',
  repopulationSecondaryInfo: 'repopulation-secondary-info',
  preQualified: 'pre-qualified',
  engine: 'engine',
  fiveKFundsPrivacyPolicy: '5k-privacy-policy',
  fiveKFundsTermsOfService: '5kfunds-terms-of-service',
  offersInfoError: 'offers-info-error',
};

export const MODALS: ModalItem[] = [
  {
    name: MODAL_NAMES.generalDisclosure,
    uid: MODAL_NAMES.generalDisclosure,
    sliceType: 'modal',
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.advertiserDisclosure,
    uid: MODAL_NAMES.advertiserDisclosure,
    sliceType: 'modal',
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.technicalTermsOfService,
    uid: MODAL_NAMES.technicalTermsOfService,
    sliceType: 'modal',
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.technicalPrivacyPolicy,
    uid: MODAL_NAMES.technicalPrivacyPolicy,
    sliceType: 'modal',
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.penniePP,
    uid: MODAL_NAMES.penniePP,
    sliceType: 'modal',
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.pennieToS,
    uid: MODAL_NAMES.pennieToS,
    sliceType: 'modal',
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.eSign,
    uid: MODAL_NAMES.eSign,
    sliceType: 'modal',
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.creditAuthorization,
    uid: MODAL_NAMES.creditAuthorization,
    sliceType: 'modal',
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.partnerList,
    uid: MODAL_NAMES.partnerList,
    sliceType: 'modal',
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.technicalCaliforniaPolicy,
    uid: MODAL_NAMES.technicalCaliforniaPolicy,
    sliceType: 'modal',
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.triPointTermsOfService,
    uid: MODAL_NAMES.triPointTermsOfService,
    sliceType: 'tripointmodal',
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.triPointPrivacyPolicy,
    uid: MODAL_NAMES.triPointPrivacyPolicy,
    sliceType: 'tripointmodal',
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.fiveKFundsPrivacyPolicy,
    uid: MODAL_NAMES.fiveKFundsPrivacyPolicy,
    sliceType: 'tripointmodal',
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.fiveKFundsTermsOfService,
    uid: MODAL_NAMES.fiveKFundsTermsOfService,
    sliceType: 'tripointmodal',
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.adDisclosure,
    uid: MODAL_NAMES.adDisclosure,
    sliceType: 'modal',
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.formSSN,
    Component: SSNForm,
    closeOnOverlayClick: false,
    title: 'Social security number',
  },
  {
    name: MODAL_NAMES.formLoanAmount,
    Component: BorrowSumForm,
    closeOnOverlayClick: false,
    title: 'Loan amount',
  },
  {
    name: MODAL_NAMES.formLoanPurpose,
    Component: LoanReasonForm,
    closeOnOverlayClick: false,
    title: 'Loan purpose',
  },
  {
    name: MODAL_NAMES.formDOB,
    Component: DOBForm,
    closeOnOverlayClick: false,
    title: 'Date of birth',
  },
  {
    name: MODAL_NAMES.formAddress,
    Component: ModalForm,
    closeOnOverlayClick: false,
    title: 'Your home address',
  },
  {
    name: MODAL_NAMES.formCreditRating,
    Component: CreditRatingForm,
    closeOnOverlayClick: false,
    title: 'Credit score',
  },
  {
    name: MODAL_NAMES.formHouseOwn,
    Component: HouseOwnForm,
    closeOnOverlayClick: false,
    title: 'Primary residence',
  },
  {
    name: MODAL_NAMES.formEducation,
    Component: EducationForm,
    closeOnOverlayClick: false,
    title: 'Education',
  },
  {
    name: MODAL_NAMES.formEmployment,
    Component: EmploymentForm,
    closeOnOverlayClick: false,
    title: 'Employment',
  },
  {
    name: MODAL_NAMES.formAnnualIncome,
    Component: AnnualIncomeForm,
    closeOnOverlayClick: false,
    title: 'Annual income',
  },
  {
    name: MODAL_NAMES.unsubscribe,
    Component: UnsubscribeContent,
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.offerPrimaryInfo,
    Component: PrimaryInfoModal,
    closeOnOverlayClick: true,
  },
  {
    name: MODAL_NAMES.securedOffer,
    Component: WarningModal,
    closeOnOverlayClick: true,
  },
  {
    name: MODAL_NAMES.offerFilters,
    Component: OfferFiltersModal,
    closeOnOverlayClick: true,
  },
  {
    name: MODAL_NAMES.repopulationSecondaryInfo,
    Component: SecondaryInfoModal,
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.preQualified,
    Component: PreQualifiedModal,
    closeOnOverlayClick: false,
  },
  {
    name: MODAL_NAMES.engine,
    Component: EngineLandingModal,
    closeOnOverlayClick: true,
  },
  {
    name: MODAL_NAMES.offersInfoError,
    Component: OffersInfoModal,
    closeOnOverlayClick: false,
  },
];
